import { createSvgIcon } from "@mui/material/utils";

export const AlertCircle = createSvgIcon(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <g clip-path="url(#clip0_974_10374)">
            <path
                d="M9.96992 6.63991V9.95991M9.96992 13.2799H9.97822M18.2699 9.95991C18.2699 14.5439 14.5539 18.2599 9.96992 18.2599C5.38596 18.2599 1.66992 14.5439 1.66992 9.95991C1.66992 5.37595 5.38596 1.65991 9.96992 1.65991C14.5539 1.65991 18.2699 5.37595 18.2699 9.95991Z"
                stroke="#F29339"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_974_10374">
                <rect
                    width="19.92"
                    height="19.92"
                    fill="white"
                    transform="translate(0.00976562)"
                />
            </clipPath>
        </defs>
    </svg>,
    "AlertCircle"
);
